const AppName = 'ToDo Tree';

export default AppName;
